import { WorkflowInstance } from '../../hooks/useGetWorkflowInstance';

export const useActionButtonState = ({
  action,
  workflowInstance,
}: {
  action: string;
  workflowInstance: Pick<
    WorkflowInstance,
    'pendingTransition' | 'transitionStatus' | 'checks'
  >;
}): { disabled: true; disabledReason: string } | { disabled: false } => {
  if (!!workflowInstance.pendingTransition) {
    return {
      disabled: true,
      disabledReason:
        'Unable to perform actions while state transition is in progress',
    };
  }

  if (!!workflowInstance.transitionStatus?.running) {
    return {
      disabled: true,
      disabledReason:
        'Unable to perform actions while state transition is in progress',
    };
  }

  if (action === 'launch') {
    const failedChecks = [...workflowInstance.checks]
      .reverse()
      .filter(check => check.state === 'FAILED')
      .map(check => ({
        disabled: true,
        disabledReason: check.message,
      }));

    if (failedChecks.length) {
      return failedChecks[0];
    }
  }

  return {
    disabled: false,
  };
};
